
export const sexChoices = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
]

export const dogSizeChoices = [
  {value:'small', label:"Small"},
  {value:'medium', label:"Medium"},
  {value:'large', label:"Large"},
  {value:'giant', label:"Giant"},
]

export const catSizeChoices = [
  {value:'small', label:'Small'},
  {value:'large', label:'Large'},
]

export const horseSizeChoices = [
  {value:'mini', label:'Mini'},
  {value:'pony', label:'Pony'},
  {value:'standard', label:'Standard'},
  {value:'draft', label:'Draft'},
]

export const otherSizeChoices = [
  {value:'small', label:'Small'},
  {value:'medium', label:'Medium'},
  {value:'large', label:'Large'},
]

export const dogColorChoices = [
  {value:'black', label:'Black'},
  {value:'brindle', label:'Brindle'},
  {value:'brown', label:'Brown'},
  {value:'gray', label:'Gray'},
  {value:'merle', label:'Merle'},
  {value:'red', label:'Red'},
  {value:'tan', label:'Tan'},
  {value:'white', label:'White'},
  {value:'yellow/gold', label:'Yellow/Gold'},
]

export const catColorChoices = [
  {value:'black', label:'Black'},
  {value:'brown', label:'Brown'},
  {value:'calico', label:'Calico'},
  {value:'gray', label:'Gray'},
  {value:'orange', label:'Orange'},
  {value:'tan', label:'Tan'},
  {value:'tortie', label:'Tortie'},
  {value:'white', label:'White'},
]

export const horseColorChoices = [
  {value:'black', label:'Black'},
  {value:'brown', label:'Brown'},
  {value:'gray', label:'Gray'},
  {value:'paint', label:'Paint'},
  {value:'red', label:'Red'},
  {value:'roan', label:'Roan'},
  {value:'tan', label:'Tan'},
  {value:'white', label:'White'},
  {value:'yellow/gold', label:'Yellow/Gold'},
]

export const otherColorChoices = [
  {value:'black', label:'Black'},
  {value:'blue', label:'Blue'},
  {value:'brown', label:'Brown'},
  {value:'gray', label:'Gray'},
  {value:'green', label:'Green'},
  {value:'orange', label:'Orange'},
  {value:'pink', label:'Pink'},
  {value:'red', label:'Red'},
  {value:'tan', label:'Tan'},
  {value:'white', label:'White'},
  {value:'yellow', label:'Yellow'},
]

export const otherAgeChoice = {
  value: 'other',
  label: 'Other'
}

export const dogAgeChoices = [
  {value:'young', label:"Young"},
  {value:'adult', label:"Adult"},
  {value:'senior', label:"Senior"},
  otherAgeChoice
]

export const catAgeChoices = [
  {value:'kitten', label:'Kitten'},
  {value:'young', label:'Young'},
  {value:'adult', label:'Adult'},
  {value:'senior', label:'Senior'},
  {value:'geriatric', label:'Geriatric'},
  otherAgeChoice
]

export const horseAgeChoices = [
  {value:'young', label:"Young"},
  {value:'adult', label:"Adult"},
  {value:'senior', label:"Senior"},
  otherAgeChoice
]

export const otherAgeChoices = [
  {value:'young', label:"Young"},
  {value:'adult', label:"Adult"},
  {value:'senior', label:"Senior"},
  otherAgeChoice
]

export const unknownChoices = [
  {value:'unknown', label:'Unknown'},
  {value:'yes', label:'Yes'},
  {value:'no', label:'No'},
]

export const statusChoices = [
  {value:'REPORTED', label:'Reported'},
  {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"},
  {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'},
  {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'},
  {value:'UNABLE TO LOCATE', label:'Unable To Locate (UTL)'},
  {value:'SHELTERED', label:'Sheltered'},
  {value:'CARE TRANSFERRED', label:'Care Transferred'},
  {value:'TRANSPORT REQUESTED', label:'Transport Requested'},
  {value:'REUNITED', label:'Reunited'},
  {value:'DECEASED', label:'Deceased'},
]

export const statusChoicesDNSF = [
  {value:'REPORTED', label:'Reported'},
  {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"},
  {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'},
  {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'},
  {value:'UNABLE TO LOCATE', label:'Unable To Locate (UTL)'},
  {value:'DID NOT SEARCH FOR', label:'Did Not Search For'},
  {value:'SHELTERED', label:'Sheltered'},
  {value:'CARE TRANSFERRED', label:'Care Transferred'},
  {value:'TRANSPORT REQUESTED', label:'Transport Requested'},
  {value:'REUNITED', label:'Reunited'},
  {value:'DECEASED', label:'Deceased'},
]

export const statusChoicesNFA = [
  {value:'REPORTED', label:'Reported'},
  {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"},
  {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'},
  {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'},
  {value:'UNABLE TO LOCATE', label:'Unable To Locate (UTL)'},
  {value:'DID NOT SEARCH FOR', label:'Did Not Search For'},
  {value:'NO FURTHER ACTION', label:'No Further Action (NFA)'},
  {value:'SHELTERED', label:'Sheltered'},
  {value:'CARE TRANSFERRED', label:'Care Transferred'},
  {value:'TRANSPORT REQUESTED', label:'Transport Requested'},
  {value:'REUNITED', label:'Reunited'},
  {value:'DECEASED', label:'Deceased'},
]

export const reportedStatusChoices = [
  {value:'REPORTED', label:'Reported'},
  {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"},
  {value:'REPORTED (SIP REQUESTED)', label:"Reported (SIP Requested)"},
  {value:'TRANSPORT REQUESTED', label:'Transport Requested'},
]

export const returnRequestedStatusChoices = [
  {value:'TRANSPORT REQUESTED', label:'Transport Requested'},
  {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'},
  {value:'SHELTERED', label:'Sheltered'},
  {value:'CARE TRANSFERRED', label:'Care Transferred'},
  {value:'REUNITED', label:'Reunited'},
  {value:'DECEASED', label:'Deceased'},
]
